export const EU_LIST = ['eu', 'fr', 'it', 'es', 'de', 'uk'];
